import React from 'react';
import {SVGModel} from '../../../framework.visual/model/svgModel';

export const ArrowLeftSVG = ({className} : SVGModel) => (
    <svg className={className} viewBox="0 0 32 32">
        <path d="M 15.987395,24.00604 7.993555,16.01209 16.000005,8.00604 24.006445,0 v 16 c 0,8.8 -0.006,16 -0.0126,16 -0.007,0 -3.60984,-3.59728 -8.00645,-7.99396 z"/>
    </svg>
);


